
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Mehr als 600’000 Corona-Fälle verzeichnet die Schweiz seit Beginn der Pandemie. Kaum bekannt ist, welche Gemeinden wie stark vom Virus betroffen sind. Neu publizierte Zahlen des Bundesamts für Gesundheit (BAG) erlauben jetzt erstmals eine detaillierte geografische Auswertung für die erste, die zweite und die beginnende dritte Welle. Gezeigt werden die täglichen Covid-Fälle pro Gemeinde auf 10’000 Einwohnerinnen und Einwohner normiert.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;